import { getEnv } from '~/utils/env';

export function getIziworkPublicURL(): string {
  return getEnv('NEXT_PUBLIC_PUBLIC_WEBSITE_URL', 'https://iziwork.com');
}
